import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { SharedComponents } from "../../shared.module";
import { MappingReviewCoverageComponent } from "../mapping-review-coverage/mapping-review-coverage.component";

/**
 * The `MappingReviewComponent` is responsible for displaying the mapping overview of test coverage
 * and reviewing the coverage based on both requirement documents and test cases. It initializes and
 * displays a detailed view of the coverage and gaps in test cases, highlighting areas of improvement.
 */
@Component({
  selector: "app-mapping-review",
  standalone: true,
  imports: [CommonModule, SharedComponents],
  templateUrl: "./mapping-review.component.html",
  styleUrl: "./mapping-review.component.scss",
})
export class MappingReviewComponent {
  mappingOverview: any;

  /**
   * Constructs the `MappingReviewComponent` and injects the `STEP_DATA` dependency.
   * @param data - The injected data, typically used for step navigation in a multi-step form or wizard.
   */
  constructor(@Inject("STEP_DATA") public data: any) {}

  /**
   * Initializes the mapping overview object with predefined coverage information and review sections.
   * This includes data for test case reviews and requirement document reviews, covering details
   * about what is covered and gaps in test coverage.
   */
  ngOnInit() {
    this.mappingOverview = {
      coverage: {
        coverage1: 52.69,
        coverage2: 92,
      },
      data: [
        {
          title: " Review Based on Requirement Document",
          headerStyle: {
            background: "#FFFFFF",
            color: "#000000",
            border: "1px solid #e1e1e1",
          },
          component: MappingReviewCoverageComponent,
          view: {
            coverage: `The test scripts, such as “CreateBookingTests.java” and “BaseSetup.java” cover a significant portion of the specified features in the SRS. They successfully address writing test cases, using Rest Assured and Selenium WebDriver, grouping test cases, and scheduling test execution, among other
            functionalities`,
            gaps: `However, critical features like end-to-end automation, test management, reporting, specific user stories, performance requirements, safety rewuirements, security requirements, and certain funcational and non-funcational requirements are not adequately covered in most scripts. These gaps indicate a lack of comprehensive test coverage in key areas as per the SRS.`,
          },
        },
        {
          title: "Review based on Test Cases",
          headerStyle: {
            background: "#FFFFFF",
            color: "#000000",
            border: "1px solid #e1e1e1",
          },
          component: MappingReviewCoverageComponent,
          view: {
            coverage: `The test scripts, such as “CreateBookingTests.java” and “BaseSetup.java” cover a significant portion of the specified features in the SRS. They successfully address writing test cases, using Rest Assured and Selenium WebDriver, grouping test cases, and scheduling test execution, among other
            functionalities`,
            gaps: `However, critical features like end-to-end automation, test management, reporting, specific user stories, performance requirements, safety rewuirements, security requirements, and certain funcational and non-funcational requirements are not adequately covered in most scripts. These gaps indicate a lack of comprehensive test coverage in key areas as per the SRS.`,
          },
        },
      ],
    };
  }
}
